module.exports = __webpack_public_path__ + "static/zjc-af30d35350d28df1a0ca5c15f47b717a.png";